import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Endereco } from '../../models/Endereco'
import { fromEvent } from 'rxjs';
import { EnderecoService } from '../../services/rest/Endereco.service'
import { EmpresaService } from '../../services/rest/Empresa.service'
import { Empresa } from '../../models/Empresa'
import { FormControl, ValidationErrors, Validators } from '@angular/forms';
import { ValidateBrService } from 'angular-validate-br';
import { Cadastro } from '../../models/Cadastro'
import { FormularioService } from '../../services/rest/Formulario.service'
import { resolveAsset } from '../../../common/support/application'

/** @title Simple form field */
@Component({
  selector: 'formulario',
  templateUrl: 'formulario.component.html',
  styleUrls: ['formulario.component.scss']
})

export class FormularioComponent implements OnInit {

  @ViewChild('cepInput', { static: true }) cepInput: ElementRef;
  @ViewChild('cnpjInput', { static: true }) cnpjInput: ElementRef;

  SISTEMA = {
    BARDERUA: 'barderua',
    MOGARABIL: 'Mogarabil',
    SGMAIN:'sgmain'
  }
  cnpjvalido = true;
  cnpjcadastrado = true;
  hideS1 = true;
  hideS2 = true;
  Cadastro: Cadastro;
  resposta: Boolean;
  aplicacaoComercial:any
  cad = {
    cnpj: "",
    situacao: "",
    nome_usuario: "",
    nome_completo: "",
    nome_fantasia: "",
    nome_usual: "",
    telefone_fixo: "",
    telefone_celular: "",
    e_mail: "",
    id_contratante: "",
    senha: "",
    confirmacao_senha: "",
    idioma: "",
    endereco: {
      situacao: "",
      municipioCodigo: "",
      estado: "",
      tipoLogradouro: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      cep: "",
      municipio: ""
    },
    servico: {
      cnpj: "",
      api_sistema_contratado: "",
      servico: "",
    },
    instalacao: {
      auto_servico: true,
      garcom: false,
      pagar_conta: false,
      delivery: false,
      qrcode: false,
      comanda_individual: false,
      comanda_mesa: false,
      buffet_kg: false,
      buffet_auto: false,
      gerencia_estoque: ""
    },
    contratante_mogarabil: {
      contratante: "",
      qualificacao_fornecedor: false,
      opcao_de_uso: "",
      negocio:null
    },
    contratante_sgmain: {
      opcao_de_uso: ""
    }
  }

  shouldShowMogarabil: boolean = false
  shouldShowMogarabilVenda: boolean = false
  estados = []
  constructor(private EnderecoService: EnderecoService, private EmpresaService: EmpresaService, private validateBrService: ValidateBrService, private FormularioService: FormularioService) { }

  ngOnInit() {

    
     this.aplicacaoComercial = 
     localStorage.removeItem('token')
    
    if (this.obterSistemaDeOrigem() === this.SISTEMA.MOGARABIL) {
      this.aplicacaoComercial = "mogarabil--logo.png"
      this.sistemaMogarabil();
    }
    if(this.obterSistemaDeOrigem() === this.SISTEMA.SGMAIN){
      this.aplicacaoComercial = "sgmain--logo.png"
      let api = this.obterAPI();
      let index = api.indexOf('.')
      let opcaoUso = api.substring(index + 1, api.length)
      this.cad.contratante_sgmain.opcao_de_uso = opcaoUso;
    }
    if(this.obterSistemaDeOrigem() === this.SISTEMA.BARDERUA){
      this.aplicacaoComercial = "barderua--logo.png"
    }






    fromEvent(this.cepInput.nativeElement, 'blur').subscribe(e => {


      this.EnderecoService.obterCep((e as any).target.value).subscribe((resultado: Endereco) => {
        this.cad.endereco.bairro = resultado.bairro;
        let index = resultado.logradouro.indexOf(" ");
        this.cad.endereco.tipoLogradouro = resultado.logradouro.substring(0, index).toUpperCase();
       
        this.cad.endereco.logradouro = resultado.logradouro.substring((index + 1), resultado.logradouro.length);
        this.cad.endereco.municipioCodigo = resultado.ibge;
        this.cad.endereco.municipio = resultado.localidade;
        this.cad.endereco.estado = resultado.uf;


      })
    })

    fromEvent(this.cnpjInput.nativeElement, 'blur').subscribe(e => {
     
      if (this.validarCNPJ((e as any).target.value)) {
        this.cnpjvalido = true;
        this.EmpresaService.obterCnpj((e as any).target.value.replace(/[^\d]+/g, '')).subscribe((resultado: Empresa) => {
          this.cad.nome_completo = resultado[0].nome_empresarial;
          this.cad.nome_fantasia = resultado[0].nome_fantasia;
          this.cad.e_mail = resultado[0].endereco_e_mail;
          this.cad.telefone_fixo = resultado[0].telefone1;
        })
      } else {
        this.cnpjvalido = false;
        this.cnpjcadastrado = true;


      }

    })




  }

  validarEmail(email) {
    if ((email.length != 0)) {
      return true;
    } else {
      return false;
    }
  }



  validarCNPJ(cnpj) {

    if (!cnpj) {
      return true;
    }
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') return false;

    if (cnpj.length != 14)
      return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999")
      return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
      return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
      return false;

    return true;

  }

  validarFormulario() {

    
   

    this.FormularioService.verificarCNPJCadastrado(this.cad.id_contratante).subscribe((resultado: any) => {

      if (resultado === true) {
        alert("Uma Unidade Gerenciada já foi cadastrada com esse CNPJ!");
        this.cad.id_contratante = "";
      }
      else if (this.cad.nome_usuario == "") {
        alert("Campo de Usuário Vazio!");

      } else if (!this.cnpjvalido) {
        alert("CNPJ Inválido!");
      } else if (this.cad.id_contratante == "") {
        alert("Preencha o campo CNPJ!");
      } else if (this.cad.nome_completo == "") {
        alert("Preencha o campo Razão Social!");
      } else if (this.cad.endereco.tipoLogradouro == "") {
        alert("Preencha o campo Tipo de Logradouro!");
      }
      else if (this.cad.endereco.cep == "") {
        alert("Preencha o campo CEP!");
      } else if (this.cad.endereco.bairro == "") {
        alert("Preencha o campo Bairro!");
      } else if (this.cad.endereco.estado == "") {
        alert("Preencha o campo Estado !");
      } else if (this.cad.endereco.municipio == "") {
        alert("Preencha o campo Municipio !");
      } else if (this.cad.endereco.numero == "") {
        alert("Preencha o campo Numero !");
      }else if (this.cad.telefone_celular == "") {
        alert("Preencha o Campo  Celular !");
      }
      else if (this.cad.e_mail == "") {
        alert("Preencha o Campo  Email !");
      } else if (this.cad.senha === "") {
        alert("Preencha o Campo  Senha !");
      } else if (this.cad.senha != this.cad.confirmacao_senha) {
        alert("As senhas não são coincidem!");
      } else {
      

        this.salvarDadosFormulario(this.cad);
      }
    })
  }

  salvarDadosFormulario(cad) {
   
    this.Cadastro = cad;
    //this.Cadastro.id_contratante = this.Cadastro.cnpj;
    this.Cadastro.situacao = 'Novo';
    this.Cadastro.endereco.situacao = 'Novo';
    this.Cadastro.servico.cnpj = this.Cadastro.id_contratante;
    this.Cadastro.servico.api_sistema_contratado = this.obterAPI();
    this.Cadastro.servico.servico = "1";
    this.Cadastro.nome_usual = this.Cadastro.nome_completo;
    this.Cadastro.status = "A";
    this.Cadastro.idioma = "1046"
    if (this.obterSistemaDeOrigem() === "Mogarabil") {
      this.cad.contratante_mogarabil.contratante = this.cad.id_contratante
      let api = this.obterAPI();
      let index = api.indexOf('.')
      this.cad.contratante_mogarabil.opcao_de_uso = api.substring(index + 1, api.length)
    }
    if (this.obterSistemaDeOrigem() === "sgmain") {
      
      let api = this.obterAPI();
      let index = api.indexOf('.')
      this.cad.contratante_sgmain.opcao_de_uso = api.substring(index + 1, api.length)
    }


    this.FormularioService.enviarDados(this.Cadastro).subscribe((resultado: any) => {

     
      alert("Cadastro Realizado com Sucesso!");

      this.voltarParaPaginaInicial();
    },

      err => alert("Ocorreu um Erro! Não foi possível realizar o cadastro!")

    )
   
  }

  limparFormulario() {
    this.cad.cnpj = "";
    this.cad.nome_completo = "";

    this.cad.endereco.cep = "";

    this.cad.endereco.bairro = "";

    this.cad.endereco.estado = "";

    this.cad.endereco.municipio = "";

    this.cad.endereco.numero = "";

    this.cad.telefone_fixo = "";
    this.cad.telefone_celular = "";

    this.cad.e_mail = "";

    this.cad.nome_fantasia = "";

    this.cad.endereco.logradouro = "";
    this.cad.endereco.complemento = "";
    this.cad.endereco.tipoLogradouro = "";
    this.cad.nome_usuario = "";
    this.cad.senha = "";
    this.cad.confirmacao_senha = "";

  }



  sistemaTributos() {
    var painelResultado = ((document.getElementById("input-cnpj") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-nome_completo") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-tipoLogradouro") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-numero") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-municipio") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-telefone_fixo") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-telefone_celular") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-nome_fantasia") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-cep") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';



    var painelResultado = ((document.getElementById("input-logradouro") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-estado") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-bairro") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-e_mail") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-nome_usuario") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-senha") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';



  }


  sistemaMogarabil() {

   
    this.cad.contratante_mogarabil.contratante = this.cad.id_contratante
    let api = this.obterAPI();
    let index = api.indexOf('.')
    let opcaoUso = api.substring(index + 1, api.length)
  
    if(opcaoUso === 'C' || opcaoUso === 'GC'){
      this.shouldShowMogarabil = true
    }else{
      this.shouldShowMogarabilVenda = true
    }
 

  }





  obterAPI() {

    let local = window.location.href;
    var api = local.split("=").pop();
    api = api.toString();
  

    return api;

  }

  obterSistemaDeOrigem(): string {


    let local = window.location.href;
    var sistema = local.split(":").pop();
    var index = sistema.indexOf("&") - 1;
    sistema = sistema.substring(0, index);
    

    return sistema;



  }

  sistemaSgmain() {
    var painelResultado = ((document.getElementById("input-cnpj") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-nome_completo") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-tipoLogradouro") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-numero") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-municipio") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-telefone_fixo") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-telefone_celular") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-nome_fantasia") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';


    var painelResultado = ((document.getElementById("input-cep") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';



    var painelResultado = ((document.getElementById("input-logradouro") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-estado") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-bairro") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-complemento") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-e_mail") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-nome_usuario") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

    var painelResultado = ((document.getElementById("input-senha") as HTMLInputElement));
    painelResultado.style.display = 'inline-block';

  }
  verficarCNPJaCadastrado() {
    this.FormularioService.verificarCNPJCadastrado(this.cad.id_contratante).subscribe((resultado: any) => {

      if (resultado === true) {
       
        // alert("Uma Unidade Gerenciada já foi cadastrada com esse CNPJ!");
        // this.cad.cnpj = "";
        this.cnpjcadastrado = false;

      } else {
        this.cnpjcadastrado = true;
      }

    })
  }
  voltarParaPaginaInicial() {

    if (this.obterSistemaDeOrigem() === 'tributos') {
      window.location.href = "http://www.tributosbrasil.com.br/";
    } else if (this.obterSistemaDeOrigem() === 'sgmain') {
      window.location.href = "http://www.sgmain.com.br/";
    } else if (this.obterSistemaDeOrigem() === 'Mogarabil') {
      window.location.href = "http://teste.mogarabil.com.br/";
    } else if (this.obterSistemaDeOrigem() === 'barderua') {
      window.location.href = "http://homologacao.barderua.com.br/gestao/";
    }else if(this.obterSistemaDeOrigem() === 'viping'){
      window.location.href = "http://teste.viping.com.br/gestao/";
    }
  }
  verificarJaCadastrado() {

    let resposta: Cadastro;
    this.FormularioService.obterUsuario(this.cad.nome_usuario).subscribe((resultado: any) => {

      if (resultado === null) {
        this.resposta = false;


      } else {
        this.resposta = true;
      }

    })



  }

  resolveAsset(filename: string): string {
  
    return resolveAsset(filename)
  }


}
